import userEventService from '../services/user-event-service';

// tracking functions
const trackDisplayed = (noteBody, predictiveIndex) => {
  const event = {
    eventCategory: 'Predictive Notes',
    eventAction: 'predictive_notes_displayed',
    eventLabel: 'predictive_notes_displayed',
    eventData: {
      predictiveIndex,
      noteBody,
    },
  };

  userEventService.trackEvent(event);
};

const trackCreated = (task, timeOption, noteBody) => {
  const event = {
    eventCategory: 'Predictive Notes',
    eventAction: 'predictive_notes_task_created',
    eventLabel: 'predictive_notes_task_created',
    eventData: {
      taskId: task.id,
      timeOption,
      noteBody,
    },
  };

  if (timeOption === 'custom') {
    event.eventData.alertDateTime = task.alert_datetime;
  }

  userEventService.trackEvent(event);
};

const trackDismissed = (noteBody) => {
  const event = {
    eventCategory: 'Predictive Notes',
    eventAction: 'predictive_notes_dismissed',
    eventLabel: 'predictive_notes_dismissed',
    eventData: {
      noteBody,
    },
  };

  userEventService.trackEvent(event);
};


export default {
  trackDisplayed,
  trackCreated,
  trackDismissed,
};
